import { computed, readonly, ref, watch } from 'vue'
import { toValue, type MaybeRefOrGetter } from 'vue'

import { fetchDocuments, type DistributorDocument } from '@/services/application'

export type DistributorDocumentFilters = {
  applicationId?: string
  userId?: string
  debtId?: string
}

export const useDistributorDocuments = (filters: MaybeRefOrGetter<DistributorDocumentFilters>) => {
  const documents = ref<DistributorDocument[]>([])
  const isLoading = ref(false)
  const error = ref('')

  const documentsById = computed(() => {
    const byId = new Map<string, DistributorDocument>()

    for (const document of documents.value) {
      byId.set(document.id, document)
    }

    return byId
  })

  const getDocuments = async () => {
    const f = toValue(filters)
    if (!f.applicationId && !f.userId && !f.debtId) {
      return
    }
    isLoading.value = true
    error.value = ''

    try {
      documents.value = await fetchDocuments(f)
    } catch (err) {
      documents.value = []
      error.value = err instanceof Error ? err.message : 'Kunde inte hämta dokument.'
    } finally {
      isLoading.value = false
    }
  }

  watch(() => toValue(filters), getDocuments, { immediate: true, deep: true })

  return {
    documents: readonly(documents),
    documentsById,
    isLoading: readonly(isLoading),
    error: readonly(error),
    getDocuments,
  }
}
